import {getDateFormat, isCurp, sanitizeString} from "../../../Apis/functions";
import {getUrlParameters} from "../../Dashboard/Visitor/External/Model/Model";
import routes from "../../../Routes/routes";

export const DOCUMENT_ID_MODEL = {
    CURP: {
        name: "CURP",
        maxChanges: 8
    },
    PASSPORT:  {
        name: "PASSPORT",
        maxChanges: 4
    }
}

export const MODEL_VERIDAS = {
    name: '',
    lastName: '',
    secondLastName: '',
    dob: null,
    gender: null,
    documentId: '',
    documentIdOriginal:'',
    maxChanges:0, //For allow or denied documentId changes for limit
    maxDeletes:0,
    isValid:function (){
        return sanitizeString(this.name) !== null && sanitizeString(this.lastName) !== null
            && this.dob !== null && this.gender !== null && sanitizeString(this.documentId) !== null;
    },
    toRegister: function () {
        return {
            name: sanitizeString(this.name),
            lastName: sanitizeString(this.lastName),
            secondLastName: sanitizeString(this.secondLastName),
            dob: this.dob,
            gender: this.gender,
            documentId: sanitizeString(this.documentId)
        }
    },
    set:function (data){
        const maxChanges = isCurp(data?.documentId) ? DOCUMENT_ID_MODEL.CURP.maxChanges : DOCUMENT_ID_MODEL.PASSPORT.maxChanges;
        return {
            ...this,
            name: data?.name || '',
            lastName: data?.lastName || '',
            secondLastName: data?.secondLastName || '',
            dob: data?.dob ? getDateFormat(data.dob, false) : null,
            gender: data?.gender || null,
            documentId: data?.documentId || '',
            documentIdOriginal: data?.documentId || '',
            maxChanges: maxChanges,
            maxDeletes: maxChanges
        }
    },
}

export const loadScript = (src, callback = null, onError = null) => {
    const isScript = document.querySelector(`script[src="${src}"]`);
    if (isScript) {
        if (callback) callback();
        return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.type = 'application/javascript';
    script.async = true;

    script.onload = () => {
        if (callback) callback();
    };

    script.onerror = () => {
        if (onError) onError();
    };

    document.head.appendChild(script);
};

/**
 * Returns the main navigation URL parameters based on the available data.
 *
 * If an `eventId` is provided, it returns the event main route.
 * Otherwise, it returns the invitation details route.
 *
 * @param {string} invitationId - Invitation identifier.
 * @param {string} [eventId] - Event identifier.
 * @param {string} [guardFlowId] - Guard flow identifier.
 * @returns {string} Generated main URL.
 */
export const getMainUrl = ({ invitationId, eventId, guardFlowId }) =>
    eventId
        ? getUrlParameters({
            url: `${routes.eventDetails.main}${eventId}`
        })
        : getUrlParameters({
            url: routes.invitationDetails.invitation,
            id: invitationId,
            guardFlowId
        });

/**
 * Returns the validation failure URL parameters based on the available data.
 *
 * If an `eventId` is provided, the event validation failure route is used.
 * Otherwise, the Veridas integration validation failure route is returned.
 *
 * @param {string} invitationId - Invitation identifier.
 * @param userId
 * @param {string} [eventId] - Event identifier.
 * @param {string} [guardFlowId] - Guard flow identifier.
 * @returns {string} Generated validation failure URL.
 */
export const getFailedUrl = ({ invitationId, userId, eventId, guardFlowId }) =>
    eventId
        ? getUrlParameters({
            url: `${routes.eventDetails.validationFail}${userId}/${eventId}`
        })
        : getUrlParameters({
            url: routes.veridasIntegration.validationFail,
            id: invitationId,
            guardFlowId
        });

/**
 * Returns the validation success URL parameters based on the available data.
 *
 * If an `eventId` is provided, the event validation success route is used.
 * Otherwise, the Veridas integration validation success route is returned.
 *
 * @param {string} invitationId - Invitation identifier.
 * @param userId
 * @param {string} [eventId] - Event identifier.
 * @param {string} [guardFlowId] - Guard flow identifier.
 * @returns {string} Generated validation success URL.
 */
export const getSuccessUrl = ({ invitationId, userId, eventId, guardFlowId }) =>
    eventId
        ? getUrlParameters({
            url: `${routes.eventDetails.successValidation}${userId}/${eventId}`
        })
        : getUrlParameters({
            url: routes.veridasIntegration.successValidation,
            id: invitationId,
            guardFlowId
        });
